import Loading from '../../../Common/Loading';
import { DeathCauseAnual } from './DeathCauseAnual';
import { DeathCauseMonth } from './DeathCauseMonth';
import { useDeathCauseChartsDataContext } from './hooks/useDeathCauseChartsDataContext';

export const Charts = () => {
    const { isLoading } = useDeathCauseChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <DeathCauseAnual />
                <DeathCauseMonth />
            </div>
        </>
    );
};
